var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Image } from '../Image';
import { UnstyledLink } from '.';
import media from '../../utils/media';
import styled from 'styled-components';
import { IMAGE_TYPE } from '../../constants';
import { isFieldValid } from '../../utils/validation';
const StyledImage = styled((_a) => {
    var { desktopHeight, desktopWidth, mobileHeight, mobileWidth, mediaType, maxWidth } = _a, others = __rest(_a, ["desktopHeight", "desktopWidth", "mobileHeight", "mobileWidth", "mediaType", "maxWidth"]);
    return (React.createElement(Image, Object.assign({}, others)));
}) `
  object-fit: ${({ mediaType }) => (mediaType === IMAGE_TYPE.ICON ? 'contain' : 'cover')};
  width: ${({ desktopWidth }) => (desktopWidth ? `${desktopWidth}px` : '100%')};
  height: ${({ desktopHeight }) => `${desktopHeight}px`};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};

  ${media.mobile} {
    width: ${({ mobileWidth, desktopWidth }) => mobileWidth ? (`${mobileWidth}px` ? desktopWidth : `${mobileWidth}px`) : '100%'};
    height: ${({ mobileHeight, desktopHeight }) => !mobileHeight ? `${desktopHeight}px` : `${mobileHeight}px`};
  }
`;
export const ImageLink = ({ media, linkField, type, desktopHeight, desktopWidth, mobileHeight, mobileWidth, maxWidth, }) => {
    if (!isFieldValid(media) || !isFieldValid(linkField)) {
        return null;
    }
    const { text: ariaLabel } = linkField.value;
    return (React.createElement(UnstyledLink, { field: linkField, ariaLabel: ariaLabel },
        React.createElement(StyledImage, { media: media, mediaType: type, desktopHeight: desktopHeight, desktopWidth: desktopWidth, mobileHeight: mobileHeight, mobileWidth: mobileWidth, maxWidth: maxWidth })));
};
export default ImageLink;
